import { store } from '../../store/store'
import router from '../../router'

export const forceLogout = async (error) => {
  var isFacebook = store.state.isFacebook

  await store.dispatch('logout', error)
  if (router.history.current.name !== 'login' || router.history.current.name !== 'nigol') {
    if (isFacebook) {
      router.push({
        path: '/' + store.getters.currentLang + '/login',
        query: router.query
      })
    } else {
      router.push({
        path: '/' + store.getters.currentLang + '/nigol',
        query: router.query
      })
    }
  }
}

export default {}



// WEBPACK FOOTER //
// ./src/plugins/main/index.js